module.exports = __webpack_public_path__ + "img/payment_success_pc.da96f977.png";